export const FETCH_HOUSES_SUCCESS = "FETCH_HOUSES_SUCCESS";
